type Props = {
  className?: string;
};

export const FinecoAgentIcon: React.FC<Props> = ({ className }) => {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="28" height="28" rx="14" fill="#00549F" />
      <path
        d="M8.8418 6.97266H19.9139V9.15754H11.6614V13.3224H19.5013V15.5073H11.6614V21.8563H8.8418V6.97266Z"
        fill="#FDC82F"
      />
    </svg>
  );
};
